(function(){
    angular.module('ui2.0Service')
        .service('fileUploadService', fileUploadService);
    function fileUploadService($http, $compile, $timeout,$modal,$rootScope){
        var self = this;
        this.bindFunctionToScope= function(){
            var scopeToBeBinded = this;
            scopeToBeBinded.openAlertBox = function (heading, str, yes, yesCb, no, noCb, url, modalScope, closeCallBack, rmvCloseBtn) {
                // console.log(str, yes, yesCb, no, noCb);
                var classIcon = "success-icon";
                var popupClass = "sirionconfirmPopup", crossBtn;
                heading = heading.toLowerCase();
                if (heading == intl_msg[24153].toLowerCase()) {
                    classIcon = "success-icon";
                    popupClass = "sirionsucessPopup";
                } else if (heading == "error" || heading == "alert") {
                    classIcon = "alertdialog-icon";
                }

                if(heading == "error"){
                    heading = intl_msg[24167];
                    popupClass = "sirionerrorPopup";
                }
                if(heading == "alert"){
                    heading = intl_msg[24168];
                    popupClass = "sirionconfirmPopup";
                }
                if(heading == "confirmation"){
                    popupClass = "sirionconfirmPopup";
                }
                if(heading == "message"){
                    classIcon = "success-icon";
                    popupClass = "sirionsucessPopup";
                    heading = intl_msg[24169]
                }
                if (yesCb == "navigateTo") {
                    crossBtn = "navigateTo";
                } else {
                    crossBtn = "cancel";
                }
                if (rmvCloseBtn) {
                    var tempElement = angular.element('<div><div class="modal-header">' + heading + '</div><div class="modal-body"><span class="' + classIcon + '">' + str + '</span></div>');
                } else {
                    var tempElement = angular.element('<div><div class="modal-header">' + heading + ' <span class="icon-close" ng-click="' + crossBtn + '()"></span></div><div class="modal-body"><span class="' + classIcon + '">' + str + '</span></div>');
                }
                var footerElem = angular.element('<div class="modal-footer"></div>');
                var yesBtn, noBtn;
                if (yes && yesCb) {
                    if (url) {
                        var fullUrl = appName + "/#" + url;
                        if (url == "/listRenderer/list/273") {
                            fullUrl = "#/listRender/273";
                        } else if (url == "/listRenderer/list/271") {
                            fullUrl = "#/listRender/271";
                        }
                        yesBtn = angular.element('<a class="anchorBtn" ng-href=' + fullUrl + '>' + yes + '</a>');
                        footerElem.append(yesBtn);
                    } else if (str == 'Please configure workflow for Contract Template.') {
                        yesBtn = angular.element('<a class="anchorBtn" ng-href="#/listRender/273">' + yes + '</a>');
                        footerElem.append(yesBtn);
                    } else if (str == 'Please configure workflow for Clause.') {
                        yesBtn = angular.element('<a class="anchorBtn" ng-href="#/listRender/271">' + yes + '</a>');
                        footerElem.append(yesBtn);
                    } else {
                        var yesBtnString = yesCb.indexOf("(true)") > -1 ? yesCb : (yesCb + "('Yes')");
                        yesBtn = angular.element('<button ng-click="' + yesBtnString + '">' + yes + '</button>');
                        footerElem.append(yesBtn);
                    }
                }
                if (no && noCb) {
                    noBtn = angular.element('<button ng-click="' + noCb + '()">' + no + '</button>');
                    footerElem.append(noBtn);
                }

                if (yes && (typeof yesCb == "undefined" || !yesCb )) {
                    yesBtn = angular.element('<button>' + yes + '</button>');
                    footerElem.append(yesBtn);
                    //   yesBtn.attr('ng-click', yesCbFn + '(' + field + ')');
                }
                tempElement.append(footerElem);


                scopeToBeBinded.modalInstance = $modal.open({
                    template: tempElement,
                    size: "375px",
                    backdrop: "static",
                    keyboard: false,
                    modalFade: true,
                    scope: modalScope ? modalScope : $rootScope,
                    // draggable : true,
                    // resizeable : false,
                    windowClass: "modal-alert " + popupClass
                    // controller:
                });
                if (closeCallBack) {
                    scopeToBeBinded.modalInstance.result.then(function () {
                        closeCallBack();
                    });
                }
                $rootScope.alertBoxes.push(scopeToBeBinded.modalInstance);
                scopeToBeBinded.modalInstance = null;
                stopLoader();
            };
            scopeToBeBinded.uploadNewFile = function (elem, returnFileElem, droppedFilesList) {
                angular.element(elem).closest('#dialogForm').find('.error').html('').hide();
                if (!droppedFilesList && elem.files && elem.files.length == 0) {
                    return;
                }
                var isDuplicate = false;
                var extraFields = [];
                if (angular.element(elem).attr("extraFields")) {
                    extraFields = JSON.parse($(elem).attr("extraFields"));
                }
                scopeToBeBinded.files = droppedFilesList != undefined ? droppedFilesList : elem.files;
                var indexFU = 0;
                var modalToClose, fileSize;

                if ($rootScope.alertBoxes.length > 0) {
                    modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                    modalToClose.close();
                }
                if ($(elem).hasClass("singleFile") && $(elem).closest("div").find(".file").size() > 0) {
                    //  alertDialog("Only one file allowed for upload.");
                    var msg = intl_msg[23560];
                    SirionUtils.openSirionDialogs({popupType: 'alert', str: msg, heading: intl_msg[24153],yesCbFn: "cancel",yesName: intl_msg[24184]});
                    return;
                }
                if ($(elem).hasClass("singleFile") && $(elem).closest("div").attr("allowedExtensions") != undefined && scopeToBeBinded.files[0] && scopeToBeBinded.files[0].name) {
                    var allowedExtenisons = $(elem).closest("div").attr("allowedExtensions");
                    var currextsn = scopeToBeBinded.files[0].name.split('.')[scopeToBeBinded.files[0].name.split('.').length - 1].toLowerCase();
                    if (allowedExtenisons.indexOf(currextsn) == -1) {
                        var msg = intl_msg[6431] + " Allowed extensions are : " + allowedExtenisons;
                        angular.element(elem).val('');
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: msg, heading: "alert",yesCbFn: "cancel",yesName: intl_msg[24184]});
                        return;
                    }
                }
                if (($(elem).closest(".formPost").hasClass("singleFile") || ($(elem).hasClass("singleFile"))) && (fileSize = calculateInputFileSize(elem.files)) > 10485760) {

                    /* alertDialog(intl_msg[6439].replace(/"/g, "")

                         +
                         parseInt(MAX_MASSEMAIL_UPLOAD_SIZE / 1000000) +
                         " MB. Currently it is more than " +
                         parseInt(fileSize / 1048576) + " MB");
                         */

                    var msg = intl_msg[6439].replace(/"/g, "") + parseInt(MAX_MASSEMAIL_UPLOAD_SIZE / 1000000) + " MB. "+intl_msg[27628]+" "
                        + parseInt(fileSize / 1048576) + " MB";
                    angular.element(elem).val('');
                    Toaster.create(msg,{iconClass:"icon-Information_filled"});
                    return;
                } else if (!$(elem).hasClass("singleFile") && (fileSize = calculateInputFileSize(elem.files)) >= 104857600) { // 100
                    // MB

                    /*  alertDialog(intl_msg[6439].replace(/"/g, "")

                          +
                          parseInt(MAX_UPLOAD_SIZE / 1000000) +
                          " MB. Currently it is more than " +
                          parseInt(fileSize / 1048576) + " MB");
          */

                    var msg = intl_msg[6439].replace(/"/g, "") + parseInt(MAX_UPLOAD_SIZE / 1000000) + " MB. "+intl_msg[27628]+" "
                        + parseInt(fileSize / 1048576) + " MB";
                    angular.element(elem).val('');
                    Toaster.create(msg,{iconClass:"icon-Information_filled"});
                    return;
                }
                if (angular.element(elem).closest('.jx-fileParentContainer').length) {
                    scopeToBeBinded.jqueryElem = $(elem).closest('.jx-fileParentContainer');
                } else {
                    scopeToBeBinded.jqueryElem = $(elem).closest('form').find('.jx-fileListDiv');
                }
                /**  previous code being commented to show popup in case of duplicate file **/
                /*$(elem).parent().find("span").each(function () {
                    if ($(this).text().trim() == $scope.files[indexFU].name) {
                        $scope.openAlertBox(intl_msg[24153], intl_msg[6553], 'OK', 'cancel', null, null);
                        isDuplicate = true;
                    }

                });*/
                /**  new code to show popup in case of duplicate file as per the new dom structure  **/
                if (scopeToBeBinded.jqueryElem.length) {
                    var fileNamesElm = scopeToBeBinded.jqueryElem.find('.jx-uplodedFN');
                    if (_.indexOf(Array.prototype.map.call(fileNamesElm, function (x) {
                            return x.innerText.trim();
                        }), scopeToBeBinded.files[indexFU].name) > -1) {
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6553], heading: intl_msg[24153],yesCbFn: "cancel",yesName: 'OK'});
                        isDuplicate = true;
                    }
                }
                /*if (angular.element(elem).closest('.jx-fileParentContainer').length) {
                    angular.element(elem).parent().find("span").each(function () {
                        if ($(this).text().trim() == scopeToBeBinded.files[indexFU].name) {
                            scopeToBeBinded.openAlertBox(intl_msg[24153], intl_msg[6553], intl_msg[24184], cancelString, null, null);
                            isDuplicate = true;
                        }
                    });
                }*/
                var filesList;
                filesList = $.extend(true, this.files, filesList);
                var invalidExtensions = [];
                var totalFiles = filesList.length;
                var fIndex = 0;
                var hasValid = 0;
                angular.forEach(filesList, function (file) {
                    var sFileName = file.name;
                    var extension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
                    if (VALIDEXTENSIONS.indexOf(extension) < 0 && invalidExtensions.indexOf(extension) < 0) {
                        invalidExtensions.push(extension);
                    } else if (VALIDEXTENSIONS.indexOf(extension) != -1) {
                        hasValid++;
                    }
                    fIndex++;
                });
                var extensionMessage = intl_msg[24187]+" " + invalidExtensions.join(',') + ".";
                if ($rootScope.alertBoxes.length == 0 && this.files.length > 0) {
                    if (invalidExtensions.length > 0 && hasValid > 0) {
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: UPLOADINPROGRESSMESSAGE + " " + extensionMessage, heading: intl_msg[24153],yesCbFn: "cancel",yesName: intl_msg[24184]});
                    } else if (invalidExtensions.length > 0 && hasValid == 0) {
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: extensionMessage, heading: intl_msg[24153],yesCbFn: "cancel",yesName: intl_msg[24184]});

                    } else {
                        Toaster.create(UPLOADINPROGRESSMESSAGE, { iconClass: "icon-Information_filled" });
                    }
                }
                if (isDuplicate) {
                    return;
                }
                //$scope.jqueryElem = $(elem).parent();
                /** changed code for positioning of uploadedfiles in new ui 2.0 **/
                if (!angular.element(elem).closest('form').find('.jx-fileListDiv').length) {
                    if (angular.element(elem).closest('.myPopUpFileUpload,.myFileUpload').next('label.noMousePointer').length > 0) {
                        angular.element(elem).closest('.myPopUpFileUpload,.myFileUpload').next('label.noMousePointer').after($('<div/>', {
                            'class': 'jx-fileListDiv'
                        }));
                    }else {
                        angular.element(elem).closest('.myPopUpFileUpload,.myFileUpload').after($('<div/>', {
                            'class': 'jx-fileListDiv'
                        }));
                    }
                }



                /** changed code for positioning of uploadedfiles in new ui 2.0 **/
                var totalFiles = scopeToBeBinded.files.length;
                var count = 0;
                angular.forEach(scopeToBeBinded.files, function (file, i) {
                    var sFileName = scopeToBeBinded.files[indexFU].name;
                    var arrayOfNamesSplitted = sFileName.split('.');
                    arrayOfNamesSplitted.splice((arrayOfNamesSplitted.length - 1), 1);
                    var sFileNameWithoutExt = arrayOfNamesSplitted.join(".");
                    var fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
                    if (hasValid == 0) {
                        stopLoader();
                    }
                    if (VALIDEXTENSIONS.indexOf(fileExtension) > -1) {
                        var action = 'onclick="angular.element(this).scope().clickThis($(this).parent().attr\(\'id\'),$(this).parent().prev())"';
                        var fileKey = commonUtil.getFileKey();
                        //  var newelem = "<span class='file' id='" + fileKey + "' file=\"" + fileKey + "\">" + escapeHtml($scope.truncateFileName(file.name)) + "&nbsp;&nbsp;&nbsp;";
                        // newelem = newelem + "<input class='upload-delete' type='button' "+action+"></input>";
                        //Changing style for bug SIR-91628
                        if (angular.element(elem).closest('.jx-fileParentContainer').length) {

                            var newelem = $('<span/>',{'class':'file jx-fileListSpan fileListSpan','id':'jx-'+fileKey,'file':fileKey,'fileName':escapeHtml(file.name)});
                            newelem.append
                            ($('<span/>',{'class':'icon-ext icon-'+fileExtension.toLowerCase()}))
                                .append($('<small/>',{'class':'jx-uplodedFN uplodedFN','title':escapeHtml(file.name),'text':escapeHtml(commonUtil.truncateFileName(file.name))}))
                                .append($('<span/>',{'class':'icon-close','onclick':"angular.element(this).scope().clickThis($(this).parent().attr('id'))"}))


                            //var newelem = "<span class='file' id='" + fileKey + "' title='" + escapeHtml(file.name) + "' style='overflow: hidden;text-overflow: ellipsis; white-space: nowrap !important;' file=\"" +     fileKey + "\">" + "<input class='upload-delete' type='button' " + action + "></input>" + escapeHtml(commonUtil.truncateFileName(file.name)) +                     "&nbsp;&nbsp;&nbsp;";
                        }
                        else {
                            var newelem = "<span class='file jx-fileListSpan' data-elemname='" + $(elem).attr('name') + "' id='" + fileKey + "' style='text-overflow: ellipsis;white-space:nowrap !important;' file=\"" + fileKey + "\"><small class='jx-uplodedFN' title='" + escapeHtml(file.name) + "'>" + escapeHtml(commonUtil.truncateFileName(file.name)) + "</small><span title='Remove' class='upload-delete icon-close' " +
                                "onclick=\"angular.element(this).scope().clickThis($(this).parent().attr('id'))\"></span>";
                        }
                        extraFields.forEach(function (d, i) {
                            var value = false;
                            if (d.properties["default"] == true) {
                                value = true;
                            }
                            if (d.name && d.type == "checkbox") {
                                newelem = newelem + "<span class='searchableBox'></span>";
                            }
                            if ([61, 160].indexOf(scopeToBeBinded.data.entityTypeId.values) > -1 && d.type == "basic" && d.properties && d.properties.multiselect == "true" && d.fields && d.fields.length > 0) {
                                var optn = "";

                                var filePropertiesTempplate = '<div  class="uploadFileProps" >' +
                                        '<i class="icon-Gear-Settings-line"  ng-class="{ \'active\' : isVisible($event,\'' + fileKey + '' + '\') }"  id="icon-Gear-Settings-line" title={{intl_msg[29024]}}  ' +
                                    'outside-if-not="propertiesSpan_'+fileKey+'" ' +
                                    'click-outside="closeProperties($event,\'' + fileKey + '' + '\')" ' +
                                    'data-ng-click  = "openProperties($event,\'' + fileKey + '' + '\')"  ></i>' +
                                    '<span  class="propertiesSpan" id="propertiesSpan_'+fileKey+'" ng-show="isVisible($event,\'' + fileKey + '' + '\')"  >' + SirionUtils.appendDocProperties(d.fields); + '</span></div>';
                                newelem = newelem + filePropertiesTempplate;
                            }
                        });
                        //newelem = newelem + "</span>";
                        // console.log("action :",angular.element(elem).attr("action"),
                        // $(elem).attr("action"),elem);
                        var fd = new FormData();
                        fd.append("documentFileData", file);
                        fd.append("name", sFileNameWithoutExt.replace(/\./g, "_"));
                        fd.append("extension", fileExtension);
                        fd.append("key", fileKey);
                        if (!$(elem).closest(".formPost") || ($(elem).closest(".formPost") && $(elem).closest(".formPost").length == 0)) {
                            var promise = $http.post(appName + angular.element(elem).attr("action"), fd, {
                                transformRequest: angular.identity,
                                headers: {
                                    "Content-Type": undefined
                                }
                            }).then(function (d) {
                                angular.element(elem).val("");
                                if (d.data == "virusvirusvirusvirus") {
                                    modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                                    modalToClose.result.then(function () {
                                        $rootScope.alertBoxes.pop();
                                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6551], heading: intl_msg[24153],yesCbFn: "cancel",yesName: intl_msg[24184]});
                                    });
                                    modalToClose.close();
                                } else if (d.data == "virusCheckFailed") {
                                    modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                                    modalToClose.result.then(function () {
                                        $rootScope.alertBoxes.pop();
                                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[27946], heading: intl_msg[24153],yesCbFn: "cancel",yesName: intl_msg[24184]});
                                    });
                                    modalToClose.close();
                                } else if (d.data == "extensionError") {
                                    modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                                    modalToClose.result.then(function () {
                                        $rootScope.alertBoxes.pop();
                                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6500], heading: intl_msg[24153],yesCbFn: "cancel",yesName: intl_msg[24184]});
                                    });
                                    modalToClose.close();
                                } else {
                                    $("[name='documentFileData']").parent().find("button").removeClass("errorClass");
                                    if ($(elem).hasClass("singleFile")) {
                                        scopeToBeBinded.SingleFileDelMsg = true;
                                        $(elem).closest(".adv-textbox").find(".singleFileUpload").hide();
                                    } else {
                                        scopeToBeBinded.SingleFileDelMsg = false;
                                    }

                                    /*//Todo :  HARADCODED - check if 'Contract Managing Unit' is 'RIHQ' then RUSSIAN GENERAL should be by-default selected - NEED TO MAKE IT GENERIC
                                    if(_.has($rootScope.data, "dynamicMetadata.dyn103684.values.id") && $rootScope.data.dynamicMetadata.dyn103684.values.id == 2073){
                                        $("span.file select").find("[value=12059]").prop("selected", true);
                                    }*/


                                    scopeToBeBinded.jqueryElem.append(newelem);
                                    //  Compile and update DOM
                                    $compile(scopeToBeBinded.jqueryElem)(scopeToBeBinded);
                                    $("span.file select").multiselect({
                                        selectedList: 4,
                                        position: {my: 'right top', at: 'right top'},
                                        open: function (event, ui) {
                                            // event handler here
                                            angular.element(event.target).closest('.jx-fileListSpan').addClass('activeSpan');
                                        },
                                        close: function (event, ui) {
                                            // event handler here
                                            angular.element(event.target).closest('.jx-fileListSpan').removeClass('activeSpan');
                                        }
                                    });
                                    $(elem).closest("span.label-height").find("span.sem").html("");
                                    count++;
                                    if (count == hasValid) {
                                        stopLoader();

                                        if ($rootScope.alertBoxes.length > 0) {
                                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                                            modalToClose.close();
                                            $rootScope.alertBoxes.pop();
                                        }
                                    }

                                    scopeToBeBinded.enableAddComment = true;
                                }
                            }, function(d) {
                                SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6552], heading: intl_msg[24153],yesCbFn: "cancel",yesName: intl_msg[24184]});
                            });
                        }
                        indexFU++;
                    }
                });
                angular.element(elem).val('');
            };
            scopeToBeBinded.clickThis = function (id) {
                if (scopeToBeBinded.SingleFileDelMsg || $(".massEmailForm").is(":visible")) {
                    SirionUtils.openSirionDialogs({popupType: 'confirm', str: intl_msg[6436], heading: intl_msg[25772],yesCbFn: "delFile",noCbFn: "notDelFile",field: id});
                } else {
                    //SIR-69055 : Didn't removed if else condition.
                    scopeToBeBinded.delFile(id);
                    // $scope.confirmAlertDialog(intl_msg[6436], "CONFIRMATION", "delFile", "notDelFile", id);
                }
            };
            scopeToBeBinded.confirmAlertDialog = function (str, heading, yesCbFn, noCbFn, field, yesName, noName, rmvCloseBtn, type,_customClass) {
                var yesBtn, noBtn;
                heading = heading.toLowerCase();
                if(heading=="confirmation"){
                    heading = intl_msg[25772];
                }
                if (window.entityURLdata && window.entityURLdata.indexOf("/contracttemplate/new") > -1 && yesCbFn && yesCbFn == "delFile") {
                    //do nothing
                } else if (window.entityURLdata && (window.entityURLdata.indexOf("/contracttemplate/clone") > -1 || window.entityURLdata.indexOf("/contracttemplate/new") > -1 || window.entityURLdata.indexOf("/clause/new") > -1 || window.entityURLdata.indexOf("/clause/clone") > -1)) {
                    var fieldJson = $.parseJSON(field);
                    if (fieldJson.api && fieldJson.api.indexOf("listRenderer/list")) {
                        fieldJson.api = fieldJson.api.replace('listRenderer/list', 'listRender');
                    }
                    field = JSON.stringify(fieldJson);
                }
                if(type=="button") {
                    var tempElement = formService.ButtonWorkFlowMessage(rmvCloseBtn,heading,str);
                }
                else {
                    if (rmvCloseBtn) {
                        var tempElement = angular.element('<div><div class="modal-header rmvCloseBtn">' + heading + '</div><div class="modal-body"><span class="success-icon">' + str + '</span></div>');
                    } else {
                        var tempElement = angular.element('<div><div class="modal-header">' + heading + '<span class="'+(_customClass?_customClass.close:"")+' icon-close" ng-click="cancel(true)"></span></div><div class="modal-body"><span class="success-icon">' + str + '</span></div>');
                    }
                }
                var footerElem = angular.element('<div class="modal-footer"></div>');
                var yesCustomClass =  _customClass?_customClass.yes:"";
                var noCustomClass =    _customClass?_customClass.no:"";
                if (field && field.indexOf(":") == -1) {
                    var yesLabel = yesName ? yesName : intl_msg[25815];
                    var noLabel = noName ? noName : intl_msg[25816];
                    yesBtn = angular.element('<button class="'+yesCustomClass+'"  ng-click="' + yesCbFn + '(\'' + field + '\')">' + yesLabel + '</button>');
                    noBtn = angular.element('<button class="'+noCustomClass+'" ng-click="' + noCbFn + '(\'' + field + '\')">' + noLabel + '</button>');
                } else {
                    var yesLabel = yesName ? yesName : intl_msg[25815];
                    var noLabel = noName ? noName : intl_msg[25816];
                    yesBtn = angular.element('<button class="'+yesCustomClass+'">' + yesLabel + '</button>');
                    yesBtn.attr('ng-click', yesCbFn + '(' + field + ')');
                    noBtn = angular.element('<button class="'+noCustomClass+'">' + noLabel + '</button>');
                    noBtn.attr('ng-click', noCbFn + '(' + field + ')');
                }
                footerElem.append(yesBtn);
                footerElem.append(noBtn);
                tempElement.append(footerElem);
                if ($.type(field) == 'object' && JSON.parse(field).name.toLowerCase() == "cancel") {
                    scopeToBeBinded.modalInstance = $modal.open({
                        template: tempElement,
                        size: "375px",
                        backdrop: "static",
                        keyboard: false,
                        scope:$scope,
                        // draggable : true,
                        // resizeable : false,
                        windowClass: "modal-alert sirionconfirmPopup"
                        // modalFade: true
                        // controller:
                    });
                } else if ($.type(field) == 'object' && JSON.parse(field).name.toLowerCase() == "success") {
                    scopeToBeBinded.modalInstance = $modal.open({
                        template: tempElement,
                        size: "375px",
                        backdrop: "static",
                        keyboard: false,
                        scope:$scope,
                        // draggable : true,
                        // resizeable : false,
                        windowClass: "modal-alert sirionsucessPopup"
                        // modalFade: true
                        // controller:
                    });
                } else {
                    scopeToBeBinded.modalInstance = $modal.open({
                        template: tempElement,
                        size: "375px",
                        backdrop: "static",
                        keyboard: false,
                        scope:scopeToBeBinded,
                        // draggable : true,
                        // resizeable : false,
                        windowClass: "modal-alert sirionerrorPopup"
                        // modalFade: true
                        // controller:
                    });
                }

                $rootScope.alertBoxes.push(scopeToBeBinded.modalInstance);
                scopeToBeBinded.modalInstance = null;

                return;

            };
            $rootScope.delFile = function (obj) {
                var d = obj;
                try {
                    if (typeof  obj == 'string'){
                        obj = JSON.parse(obj);
                        d = obj.id;
                    }

                } catch (e){

                }
                $("#scheduleForm .adv-textbox .singleFileUpload").fadeIn();
                //if(obj.modelToRemove){SirionUtils.setValueOfNDepth($scope,obj.modelToRemove,null)}
                $("#" + d).remove();

                $rootScope.cancel();
            }
            $rootScope.notDelFile = function (d) {
                $rootScope.cancel();
            };
            $rootScope.cancel = function () {
                $rootScope.dateAlert = false;
                stopLoader();
                var modalToClose;
                var modalPresent = false;
                if ($rootScope.alertBoxes.length > 0) {
                    modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                    modalToClose.close();
                    modalPresent = true;
                }
                if (modalToClose) {
                    modalToClose.result.then(function () {
                        $rootScope.alertBoxes.pop();

                    });
                }



            };
        }


    }
    fileUploadService.$inject = ['$http', '$compile', '$timeout','$uibModal','$rootScope'];
})();